<template>
    <div class="wrap">
        <div class="exports-wrap">
            <div class="line-item toolbar">
                <div class="left-item"></div>
            </div>
            <div class="exports-wrap">
                <div class="row">
                    <div class="col-2" style="margin-top: 7px;">
                        <span style="font-size: 15px; color: black; font-weight: 550; ">Start Date </span>
                        <datepicker v-model="startDate" format="MM-dd-yyyy" name="uniquename"></datepicker>
                    </div>
                    <div class="col-2" style="margin-top: 7px;">
                        <span style="font-size: 15px; color: black; font-weight: 550; ">End Date </span>
                        <datepicker v-model="endDate" format="MM-dd-yyyy" name="uniquename"></datepicker>
                    </div>
                    <div class="col-8" >
                        <span>
                            <md-checkbox style="position: relative;top: 8px; margin-left: 26px;" v-model="arrayData" value="failed">Failed</md-checkbox>
                            <md-checkbox style="position: relative;top: 8px; margin-left: 26px;" v-model="arrayData" value="inprocess">In-process</md-checkbox>
                            <md-checkbox style="position: relative;top: 8px; margin-left: 26px;" v-model="arrayData" value="completed">Completed</md-checkbox>
                            <md-checkbox style="position: relative;top: 8px; margin-left: 26px;" v-model="arrayData" value="deleted">Deleted</md-checkbox>
                            <md-button class="submit-analytics-button md-primardy" @click="loadQueueData()">Apply</md-button>
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="exportDataNotFound" class="righContent" style="float: right; margin-top: 28px;font-size: initial;">
                    <span style="font-size: 15px; color: black; font-weight: 550;">Total Jobs:</span> {{ jobsCount }}
                </div>
                <section class="page-content settings">
                    <div style="width:100%; max-height:400px; overflow-y: auto; overflow-x: auto;">
                        <table id="firstTable" style="width:100%">
                            <thead>
                            <tr>
                                <th>CLIENT NAME</th>
                                <th>Tour Name</th>
                                <th>CREATED AT</th>
                                <th>STARTED AT</th>
                                <th>Completed AT</th>
                                <th>attempts</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="exportDataNotFound">
                                <tr v-for="exports in exportLists" :key="exports.jobId" v-if="country === 'runningJobs'">
                                    <td>{{ exports.ClientName }}</td>
                                    <td>
                                        <div v-for="code in splitedList(exports.tourName)">
                                            <span @click="openCLientCListPage(exports.tourAllDetails)"><a>{{ code }}</a></span><br>
                                        </div>
                                    </td>
                                    <td>{{ exports.createAt }}</td>
                                    <td>{{ exports.startedAt }}</td>
                                    <td>{{ exports.completedAt }}</td>
                                    <td v-if="exports.queueJobFaild ==1">3</td>
                                    <td v-else>1</td>
                                    <td v-if="exports.queueJobFaild==0">In-process</td>
                                    <td v-else-if="exports.completedAt =='0000-00-00 00:00:00'">In-process</td>
                                    <td v-else-if="exports.queueJobFaild == 1">Failed</td>
                                    <td v-else-if="exports.deleted_at != null">Deleted</td>
                                    <td v-else>Completed</td>
                                    <td>
                                        <md-button v-if="exports.queueJobFaild =='0'" class="md-accent md-raised" style="background-color:#d9534f !important; height:25px; font-size:12px; padding:5px 0;color:white;" @click="showModalPop(exports.exportId)">CANCEL</md-button>
                                        <md-button v-if="exports.queueJobFaild =='1'" class="md-accent md-raised" style="background-color:#00A8CA !important; height:25px; font-size:12px; padding:5px 0;color:white;" @click="showModalPopRestart(exports.queueJobId)">RESTART</md-button>
                                        <md-button v-if="exports.completedAt =='0000-00-00 00:00:00'" class="md-accent md-raised" style="background-color:#00A8CA !important; height:25px; font-size:12px; padding:5px 0;color:white;" @click="showModalPop(exports.exportId)">CANCEL</md-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="exportJobs" style="margin-top:100px;" v-if="exportDataNotFound">
                        <highcharts :options="chartOptions"></highcharts>
                    </div>
                    <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
                        <md-dialog-title>
                            Confirm Delete
                        </md-dialog-title>
                        <md-dialog-content>
                            Are you sure you want to delete this Jobs?
                        </md-dialog-content>
                        <md-dialog-actions class="full-btn">
                            <md-button class="ManualBtn ManualBtndelete" @click="deleteClient(exportIdQueue)">Delete</md-button>
                            <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">Cancel</md-button>
                        </md-dialog-actions>
                    </md-dialog>
                    <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogRe">
                        <md-dialog-title>
                            Confirm Restart
                        </md-dialog-title>
                        <md-dialog-content>
                            Are you sure you want to Restart this Jobs?
                        </md-dialog-content>
                        <md-dialog-actions class="full-btn">
                            <md-button class="ManualBtn ManualBtndelete" @click="reStartQueueJob(reStartJobID)">Restart</md-button>
                            <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogRe = false">Cancel</md-button>
                        </md-dialog-actions>
                    </md-dialog>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import {Chart} from 'highcharts-vue';
import Datepicker from 'vuejs-datepicker';
import VueMoment from 'vue-moment';
import {deteleQueueJob, reStartQueueJobApi} from '../../services/ToursService';
import axios from 'axios';
import {mapActions, mapGetters} from 'vuex';

export default {
  data () {
    return {
      dateMaxValueStart: '',
      dateMaxValueEnd: '',
      message: 'rajesh',
      startDate: '',
      endDate: new Date(),
      arrayData: [],
      showDeleteDialogRe: false,
      exportListsWent: false,
      exportDataNotFound: true,
      exportLists: [],
      country: 'runningJobs',
      showDeleteDialog: false,
      jobsCount: '',
      exportIdQueue: '',
      jobIdQueue: '',
      reStartJobID: '',
      chartOptions: {
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        chart: {
          renderTo: 'container',
          customData: ''
        },
        xAxis: {
          type: 'datetime'
        },
        plotOptions: {
          column: {
            // pointStart: Date.UTC(2010, 0, 1) // feb 12, 2015
          },
          series: {
            events: {
              legendItemClick: function () {
                var PloatSingleData = [];
                let pp = this;
                setTimeout(function () {
                  pp.chart.series.forEach(function (sr) {
                    if (sr.visible) {
                      PloatSingleData.push(sr.name);
                    }
                  });
                  if (PloatSingleData.length > 1) {
                    pp.chart.series[0].setData(pp.chart.series[0].userOptions.mainData);
                    pp.chart.series[1].setData(pp.chart.series[1].userOptions.mainData);
                    pp.chart.series[2].setData(pp.chart.series[2].userOptions.mainData);
                  } else {
                    if (PloatSingleData.length === 1 && PloatSingleData[0] === 'Job Count (Queue Job Count)') {
                      pp.chart.series[0].setData(pp.chart.series[0].userOptions.customData);
                    }
                    if (PloatSingleData.length === 1 && PloatSingleData[0] === 'Job Size (Export Data MB)') {
                      pp.chart.series[1].setData(pp.chart.series[1].userOptions.customData);
                    }
                    if (PloatSingleData.length === 1 && PloatSingleData[0] === 'Job Complexity (Triggers/File Count)') {
                      pp.chart.series[2].setData(pp.chart.series[2].userOptions.customData);
                    }
                  }
                }, 20);
              }
            },
            step: 'left'
          }
        },
        tooltip: {
          xDateFormat: '%m-%d-%Y %H:%M'
        },
        series: '',
        customData: ''
      }
    };
  },
  components: {
    highcharts: Chart,
    Datepicker: Datepicker,
    VueMoment: VueMoment
  },
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient'])
  },
  methods: {
    ...mapActions('client', ['loadClient']),
    ...mapActions('tours', ['loadTourEditor', 'loadClientToursList']),
    ...mapActions('map', ['setCenter']),
    openCLientCListPage (clientID) {
      let pp = this;
      this.loadClient({isAdmin: false, clientId: clientID.clientId}).then(() => {
        pp.loadClientToursList(clientID.clientId).then(() => {
          pp.setCenter(clientID);
          pp.loadTourEditor(clientID).then(() => {
            pp.$router.push('/tour');
          });
        });
      });
    },
    splitedList (row) {
      return (row !== null) ? row.split(',') : '';
    },
    customFormatter () {
      return VueMoment(this.startDate).format('MMMM DD YYYY');
    },
    getExportJobsList () {
      var queueJobData = {
        arrayData: this.arrayData,
        startDate: this.startDate,
        endDate: this.endDate
      };
      axios.post('api/client/getAllJobRunningData', queueJobData).then((response) => {
        this.isLoading = false;
        if (response.data === 1) {
          this.exportListsWent = true;
        } else {
          if (response.data.length === 0) {
            this.exportDataNotFound = false;
          } else {
            this.exportDataNotFound = true;
            this.exportLists = response.data.tableData;
            this.jobsCount = response.data.tableData.length;
            var seri = [{
              name: 'Job Count (Queue Job Count)',
              customData: response.data.created_atForGraph,
              color: '#00A8CA',
              mainData: response.data.jobCountNorm,
              data: response.data.jobCountNorm
            }, {
              name: 'Job Size (Export Data MB)',
              customData: response.data.jobFilsSizeMainData,
              color: 'rgb(217, 83, 79)',
              mainData: response.data.jobFilsSizeNormData,
              data: response.data.jobFilsSizeNormData
            }, {
              name: 'Job Complexity (Triggers/File Count)',
              customData: response.data.jobComplexityMainData,
              color: 'rgb(67,67,72)',
              mainData: response.data.jobComplexityNormData,
              data: response.data.jobComplexityNormData
            }];
            this.chartOptions.series = seri;
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    loadQueueData () {
      this.getExportJobsList();
    },
    showModalPop (exportId) {
      this.exportIdQueue = exportId;
      this.showDeleteDialog = true;
    },
    showModalPopRestart (jobId) {
      this.reStartJobID = jobId;
      this.showDeleteDialogRe = true;
    },
    deleteClient (exportId) {
      var forThis = this;
      deteleQueueJob(exportId).then(function (responce) {
        if (responce.data === exportId) {
          forThis.showDeleteDialog = false;
          forThis.getExportJobsList();
        }
      });
    },
    reStartQueueJob (jobId) {
      var forThis = this;
      reStartQueueJobApi(jobId).then(function (responce) {
        if (responce.data === jobId) {
          forThis.showDeleteDialogRe = false;
          forThis.getExportJobsList();
        }
      });
    }
  },
  mounted () {
    this.arrayData.push('failed');
    this.arrayData.push('inprocess');
    this.arrayData.push('completed');
    this.arrayData.push('deleted');
    let startDate = new Date();
    startDate.setDate(startDate.getDate() - 14);
    this.startDate = startDate;
    this.getExportJobsList();
  }
};
</script>

<style scoped type="scss">
.md-button:not([disabled])
.md-focused:before,
.md-button:not([disabled]):active:before,
.md-button:not([disabled]):hover:before {
    background-color: white !important;
    opacity: 0 !important;
}

.md-icon-button .md-ripple {
    border-radius: 0px !important;
    padding: 0px !important;
}

.exports-wrap .inner-line:hover {
    background-color: #EEEEEE;
}

.exports-wrap .search .search-glass-icon {
    position: absolute !important;
}

.exports-wrap .search .md-icon {
    height: 36px !important;
    font-size: 24px !important;
}

.exports-wrap .search {
    margin-top: 8px !important;

.md-input {
    width: 100% !important;
    padding-right: 36px !important;
}

}
.exports-wrap .search .md-button.md-icon-button {
    left: 0px !important;
    top: 0px !important;
}

.exports-wrap .search input {
    width: 360px;
    font-size: 100%;
}

.exports-wrap .upload-btn .file-input {
    position: absolute;
    left: -15px;
    height: 100px !important;
    width: 100px;
    opacity: 0;
}

.exports-wrap .toolbar .right-item {
    height: 48px;
    padding-top: 10px;
}

.exports-wrap .toolbar .right-item .upload-text {
    margin: 0px;
    padding: 0px;
    width: auto;
}

.upload-text {
    height: 75px;
    margin-left: 100px;
    width: 344px;
    display: inline-block;
}

.loading-icon {
    display: inline-block;
    width: 35px;
}

.fill-modal {
    width: 544px;
}

.tour-buttons .upload-btn {
    background-color: rgb(0, 168, 202) !important;
    color: rgba(255, 255, 255, 0.87) !important;
}

.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

button {
    z-index: 15;
}

}
.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.exports-item {
    cursor: pointer;
}

.line-item .left-item .el.mav-bar-export {
    margin-right: 200px;
}

table {
    font-family: 'Open Sans', sans-serif;
    width: 100%;
    border-collapse: collapse;
    margin: 10px 10px 0 10px;
}

  table th {
    text-transform: uppercase;
    text-align: left;
    background: #00A8CA;
    color: #FFF;
    padding: 8px;
    min-width: 30px;
    max-width: fit-content;
  }

table td {
    text-align: left;
    padding: 5px;
    line-height: 35px;
    border-right: 2px solid #7D82A8;
    border-bottom: 2px solid #7D82A8;
}

table td:last-child {
    border-right: none;
    min-width: 90px;
}

table tbody tr:nth-child(2n) td {
    background: rgba(0, 0, 0, 0.2);
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
    margin: 0 8px;
    float: left;
    width: 19%;
    padding: 8px !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.greenRecord {
    color: green;
}

.somethingWent {
    color: red;
}

.submit-analytics-button {
    background-color: #00A8CA;
    margin: 0;
    margin-top: 15px;
    color: white;
}

.submit-analytics-button:hover {
    background-color: #00A8CA;
    margin: 0;
    color: white;
    margin-top: 15px;
}

table th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 12;

}
</style>



// WEBPACK FOOTER //
// src/components/settings/ExportJobs.vue